import React from "react";
class Once extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            clicked: false
        };
    }
    render() {
        const { defaultValue, children } = this.props;
        const { clicked } = this.state;
        return React.cloneElement(children(!clicked && defaultValue), {
            onClick: () => {
                this.setState({ clicked: true });
            },
        });
    }
}
export default Once;
